/**
 * Client-side defaults for list pages until system_modules.module_config is populated in DB.
 * API module_config from GET /api/metadata/{module} overrides these values.
 */
export const MODULE_LIST_REGISTRY = {
  organization_project_projects: {
    filteredEndpoint: '/api/project-management/projects/filtered',
    defaultSort: { field: 'project_name', direction: 'asc' },
    context: {},
    lookupContext: {},
  },


  
  organization_project_tasks: {
    filteredEndpoint: '/api/project-management/project-tasks/filtered',
    defaultSort: { field: 'scheduled_date', direction: 'desc' },
    context: {},
    lookupContext: {},
  },
};

/** Same filter module, different list context (employee vs intern). */
export const MODULE_LIST_VARIANTS = {
  'organization_project_tasks:employee': {
    context: { person_type_id: 1 },
    lookupContext: { person_type_id: 1 },
  },
  'organization_project_tasks:intern': {
    context: { person_type_id: 2 },
    lookupContext: { person_type_id: 2 },
  },
};

/**
 * Merge registry + variant + API module_config into one list config object.
 */
export function resolveModuleListConfig(filterModule, variantKey = null, apiModuleConfig = null) {
  const base = MODULE_LIST_REGISTRY[filterModule] || {};
  const variant =
    variantKey && MODULE_LIST_VARIANTS[`${filterModule}:${variantKey}`]
      ? MODULE_LIST_VARIANTS[`${filterModule}:${variantKey}`]
      : {};

  const fromApi =
    apiModuleConfig && typeof apiModuleConfig === 'object' ? apiModuleConfig : {};

  const listFromApi = fromApi.list || fromApi;
  const lookupFromApi = fromApi.lookup_context || fromApi.lookupContext || {};

  return {
    filteredEndpoint:
      listFromApi.filtered_endpoint ||
      listFromApi.filteredEndpoint ||
      base.filteredEndpoint ||
      null,
    defaultSort:
      listFromApi.default_sort ||
      listFromApi.defaultSort ||
      base.defaultSort ||
      { field: 'created_at', direction: 'desc' },
    context: {
      ...(base.context || {}),
      ...(variant.context || {}),
      ...(listFromApi.context || {}),
    },
    lookupContext: {
      ...(base.lookupContext || {}),
      ...(variant.lookupContext || {}),
      ...(lookupFromApi || {}),
    },
  };
}
